<template>
  <b-modal
    :visible="visible"
    centered
    hide-header
    hide-footer
    size="md"
    modal-class="suspended-entity-modal-wrap"
    content-class="suspended-entity-modal-content"
    @change="$emit('update:visible', $event)"
  >
    <div class="suspended-modal-body text-center">
      <div class="suspended-modal-icon-wrap mb-1">
        <feather-icon :icon="entityType === 'user' ? 'UserXIcon' : 'BriefcaseIcon'" size="42" />
      </div>
      <h3 class="suspended-modal-title">{{ title }}</h3>
      <p class="suspended-modal-text text-muted mb-2">{{ message }}</p>
      <div v-if="entity" class="suspended-entity-card mb-2">
        <b-avatar :src="entity.avatar" size="48" class="mb-50" />
        <div class="font-weight-bolder">{{ entity.name }}</div>
        <small class="text-muted">{{ entity.contact || entity.email || '' }}</small>
        <div v-if="entity.suspendedOn" class="mt-50">
          <span class="mypoda-status-tag status-inactive">Suspended · {{ entity.suspendedOn }}</span>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <b-button variant="primary" class="mr-1" @click="$emit('primary')">{{ primaryLabel }}</b-button>
        <b-button variant="outline-secondary" @click="$emit('update:visible', false)">Close</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BAvatar, BButton, BModal } from 'bootstrap-vue'

export default {
  name: 'SuspendedEntityModal',
  components: { BAvatar, BButton, BModal },
  props: {
    visible: { type: Boolean, default: false },
    entityType: { type: String, default: 'user' },
    title: { type: String, default: 'Suspended Account' },
    message: { type: String, default: 'This account is currently suspended.' },
    primaryLabel: { type: String, default: 'Unsuspend' },
    entity: { type: Object, default: () => ({}) },
  },
}
</script>

<style scoped lang="scss">
.suspended-modal-icon-wrap {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #ffe2e3;
  color: #ea5455;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.suspended-modal-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #2f2b3d;
}

.suspended-entity-card {
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  padding: 1rem;
  background: #fafafe;
}
</style>
